import React, { createContext, useCallback, useEffect, useState } from "react";

export const AuthContext = createContext({
  isLogged: false,
  login: () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(false);

  // initialize from localStorage on mount
  useEffect(() => {
    try {
      const flag = localStorage.getItem("login") === "true";
      setIsLogged(flag);
    } catch (e) {
      setIsLogged(false);
    }
  }, []);

  // listen for other tabs changing login flag
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "login") {
        setIsLogged(e.newValue === "true");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const login = useCallback(() => {
    try {
      localStorage.setItem("login", "true");
    } catch (e) {}
    setIsLogged(true);
    // also dispatch a storage event for same-tab listeners
    window.dispatchEvent(new StorageEvent("storage", { key: "login", newValue: "true" }));
  }, []);

  const logout = useCallback(() => {
    try {
      localStorage.removeItem("login");
    } catch (e) {}
    setIsLogged(false);
    window.dispatchEvent(new StorageEvent("storage", { key: "login", newValue: null }));
  }, []);

  return (
    <AuthContext.Provider value={{ isLogged, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
